/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { publicHolidayIdGet } from '../fn/public-holiday/public-holiday-id-get';
import { PublicHolidayIdGet$Params } from '../fn/public-holiday/public-holiday-id-get';
import { publicHolidayPost } from '../fn/public-holiday/public-holiday-post';
import { PublicHolidayPost$Params } from '../fn/public-holiday/public-holiday-post';
import { PublicHolidayRecordModel } from '../models/public-holiday-record-model';
import { PublicHolidayRecordModelSearchResultModel } from '../models/public-holiday-record-model-search-result-model';
import { publicHolidaySearchPublicHolidayPost } from '../fn/public-holiday/public-holiday-search-public-holiday-post';
import { PublicHolidaySearchPublicHolidayPost$Params } from '../fn/public-holiday/public-holiday-search-public-holiday-post';

@Injectable({ providedIn: 'root' })
export class MDIPublicHolidayService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `publicHolidaySearchPublicHolidayPost()` */
  static readonly PublicHolidaySearchPublicHolidayPostPath = '/PublicHoliday/SearchPublicHoliday';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publicHolidaySearchPublicHolidayPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publicHolidaySearchPublicHolidayPost$Response(params?: PublicHolidaySearchPublicHolidayPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<PublicHolidayRecordModelSearchResultModel>> {
    return publicHolidaySearchPublicHolidayPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publicHolidaySearchPublicHolidayPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publicHolidaySearchPublicHolidayPost(params?: PublicHolidaySearchPublicHolidayPost$Params, context?: HttpContext): Observable<PublicHolidayRecordModelSearchResultModel> {
    return this.publicHolidaySearchPublicHolidayPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<PublicHolidayRecordModelSearchResultModel>): PublicHolidayRecordModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `publicHolidayIdGet()` */
  static readonly PublicHolidayIdGetPath = '/PublicHoliday/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publicHolidayIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  publicHolidayIdGet$Response(params: PublicHolidayIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<PublicHolidayRecordModel>> {
    return publicHolidayIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publicHolidayIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publicHolidayIdGet(params: PublicHolidayIdGet$Params, context?: HttpContext): Observable<PublicHolidayRecordModel> {
    return this.publicHolidayIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<PublicHolidayRecordModel>): PublicHolidayRecordModel => r.body)
    );
  }

  /** Path part for operation `publicHolidayPost()` */
  static readonly PublicHolidayPostPath = '/PublicHoliday';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publicHolidayPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publicHolidayPost$Response(params?: PublicHolidayPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return publicHolidayPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publicHolidayPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publicHolidayPost(params?: PublicHolidayPost$Params, context?: HttpContext): Observable<string> {
    return this.publicHolidayPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
